import { event } from "analytics";
import { useDispatch } from "react-redux";
import { setCamera } from "redux/actions/cameraActions";
import { hideModal } from "redux/actions/modalActions";

const CATEGORY = "take_photos_incident";

export const useMediaModal = ({ uploadPicturesInput }) => {
  const dispatch = useDispatch();

  const selectCamera = () => {
    dispatch(hideModal({ type: "media" }));
    dispatch(setCamera(true));
    event("camera", CATEGORY);
  };

  const handleClose = () => {
    event("close", CATEGORY);
    dispatch(hideModal({ type: "media" }));
  };

  const selectMediaGallery = () => {
    uploadPicturesInput.current.click();
    dispatch(hideModal({ type: "media" }));
    event("photo_library", CATEGORY);
  };

  return { selectCamera, handleClose, selectMediaGallery };
};
